export default "__VITE_ASSET__BaHgWEUS__"